import serverApi from './serverApi'

export default {
   ...serverApi,
}